import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { TextButtonWithIconComponent } from './text-button-with-icon/text-button-with-icon.component';
import { BasicButtonComponent } from './basic-button/basic-button.component';
import { IconButtonComponent } from './icon-button/icon-button.component';
import { MatRippleModule } from '@angular/material/core';
import { DropdownButtonComponent } from './dropdown-button/dropdown-button.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DirectiveModule } from '@app/shared/directives/directive.module';
import { SplitButtonComponent } from './split-button/split-button.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    TranslateModule,
    MatRippleModule,
    MatButtonToggleModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    DirectiveModule,
  ],
  exports: [
    BasicButtonComponent,
    TextButtonWithIconComponent,
    IconButtonComponent,
    DropdownButtonComponent,
    SplitButtonComponent,
  ],
  declarations: [
    BasicButtonComponent,
    TextButtonWithIconComponent,
    IconButtonComponent,
    DropdownButtonComponent,
    SplitButtonComponent,
  ],
})
export class ButtonsModule {}
